import { buildTenantColorsCss } from "~/utils/tenant-colors-css";

// rcp-10: aplica los colores de marca en RUNTIME desde $tenantConfig (cargado por runtime-config).
// (1) Inyecta un <style id="tenant-colors"> con las CSS vars (--brand-*, --color-* de zonas, --q-*)
//     ANTES de onNuxtReady para minimizar FOUC. Sustituye al colors.css horneado (retirado de nuxt.config).
// (2) Muta el tema Vuetify (themes.light.primary/secondary/accent) — reactivo en Vuetify 2 — cuando el
//     instance está listo.
export default function themePlugin(ctx) {
	if (!process.client) return;
	const cfg = ctx.$tenantConfig;
	const colors = cfg && cfg.colors;
	if (!colors) return;

	const styleEl = document.createElement("style");
	styleEl.id = "tenant-colors";
	styleEl.textContent = buildTenantColorsCss(colors);
	document.head.appendChild(styleEl);

	window.onNuxtReady((nuxt) => {
		const light =
			nuxt.$vuetify && nuxt.$vuetify.theme && nuxt.$vuetify.theme.themes && nuxt.$vuetify.theme.themes.light;
		if (!light) return;
		if (colors.primary) light.primary = colors.primary;
		if (colors.secondary) light.secondary = colors.secondary;
		if (colors.accent) light.accent = colors.accent;
	});
}
